import { ProductsConfig } from '../../../interfaces/mock.interface';

export const PLANS_MOCK: ProductsConfig[] = [
    {
        label: 'B&You 100Go',
        gencode: '6712',
    },
    {
        label: 'B&You 50Go',
        gencode: '6305',
    },
    {
        label: '130Go 5G SIM Seule',
        gencode: '6850',
    },
    {
        label: '200Go 5G SIM Seule',
        gencode: '6852',
    },
    {
        label: '130Go 5G av. smartphone',
        gencode: '6847',
    },
    {
        label: '150Go 5G av. smartphone',
        gencode: '6848',
    },
];
